<script>
  import { SectionWrapper } from "paxray-components-svelte";
  import Header from "lib/components/Header.svelte";
  import MatrixTable from "./components/MatrixTable.svelte";
  import { filtersConfigStore } from "@stores/filtersConfigStores.js";
  import { getApplicableFilters } from "../../../../lib/util/getApplicableFilters";
  import Filter from "./components/filter/Filter.svelte";

  import { pmfilters } from "lib/stores.js";
  import { fetchWithSession } from "../../../../lib/util/fetchWithSession.js";
  import {
    formatTimeDelta,
    formatPercentage,
  } from "../../../../lib/util/formatfunctions.js";
  import FilterToast from "./components/FilterToast.svelte";

  export let analysisid;

  const { setCurrentView } = filtersConfigStore;

  let view = "KPI Matrix";
  let applicationlist = [];
  let loading = true;
  let header = [
    "Applications",
    "Number of Cases",
    "Execution Time",
    "Time Per Case",
    "Time Per Relevant Case",
    "Time Per Activity",
    "Execution Frequency",
    "Execution Frequency Per Case",
    "Execution Frequency Per Relevant Case",
    "Number of Applications",
    "Number of Window Titles",
    "Case Coverage",
  ];
  let rows = [];

  let showToast = false;

  $: setCurrentView(view);

  $: {
    if ($pmfilters && $filtersConfigStore.storeLoaded) getWindowPartitions();
  }

  function getWindowPartitions() {
    const applicableFilters = getApplicableFilters($pmfilters[analysisid]);
    const filterString = JSON.stringify(applicableFilters);
    fetchWithSession(
      `/api/analysis/cases/getActivityKPIs/${analysisid}?filter=${filterString}`
    )
      .then((res) => res.json())
      .then((data) => {
        applicationlist = data;
        setRows(applicationlist);
        if (
          (Array.isArray(data) && data.length === 0) ||
          (typeof data === "object" &&
            data !== null &&
            Object.keys(data).length === 0)
        ) {
          showToast = true;
        }
        loading = false;
      });
  }

  function setRows(applicationlist) {
    rows = Object.keys(applicationlist).map((key) => {
      const app = applicationlist[key];
      return [
        key,
        app.ncases,
        formatTimeDelta(Number(app.totalExecutionTime)),
        formatTimeDelta(Number(app.timePerCase)),
        formatTimeDelta(Number(app.timePerRelevantCase)),
        formatTimeDelta(Number(app.timePerActivity)),
        app.totalExecutionFrequency,
        app.executionFrequencyPerCase.toFixed(2),
        app.executionFrequencyPerRelevantCase.toFixed(2),
        app.napplications,
        app.nwindowtitles,
        formatPercentage(Number(app.caseCoverage)),
      ];
    });
  }
</script>

<FilterToast bind:showToast />

<Header section="KPI" breadcrumb="Matrix">
  <Filter />
</Header>

<SectionWrapper splitScreen={true} fullscreen>
  <main slot="main" class="main">
    <MatrixTable {header} {rows} {loading}></MatrixTable>
  </main>
</SectionWrapper>

<style>
  .main {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    z-index: 0;
  }
</style>
